<i18n>
{
  "de": {
    "images": "Bilddatei(en)",
    "videos": "Videodatei(en)",
    "audios": "Audiodatei(en)",
    "pdfs": "PDF-Datei(en)",
    "zips": "Zip-Datei(en)",
    "extlink_included": "Externer Link enthalten",
    "livestream_included": "Livestream-URL enthalten"
  },
  "en": {
    "images": "Image file(s)",
    "videos": "Video file(s)",
    "audios": "Audio file(s)",
    "pdfs": "PDF file(s)",
    "zips": "ZIP file(s)",
    "extlink_included": "External link included",
    "livestream_included": "Livestream link included"
  }
}
</i18n>

<template>
  <div
    v-if="hasMedia"
    class="stats-icons mt-10"
  >
    <hr class="mb-15">
    <ul class="icon-holder">
      <li v-if="post.stats.images">
        <abbr :title="`${post.stats.images} ${$t('images')}`">
          <i class="icon-photo active" />
        </abbr>
      </li>
      <li v-if="post.stats.videos">
        <abbr :title="`${post.stats.videos} ${$t('videos')}`">
          <i class="icon-video active" />
        </abbr>
      </li>
      <li v-if="post.stats.audios">
        <abbr :title="`${post.stats.audios} ${$t('audios')}`">
          <i class="icon-audio active" />
        </abbr>
      </li>
      <li v-if="post.stats.pdfs">
        <abbr :title="`${post.stats.pdfs} ${$t('pdfs')}`">
          <i class="icon-pdf active" />
        </abbr>
      </li>
      <li v-if="post.stats.zips">
        <abbr :title="`${post.stats.zips} ${$t('zips')}`">
          <i class="icon-zip active" />
        </abbr>
      </li>
      <li v-if="post.stats.externalLink">
        <abbr :title="`${$t('extlink_included')}`">
          <i class="icon-link active" />
        </abbr>
      </li>
      <li v-if="post.stats.livestream">
        <abbr :title="`${$t('livestream_included')}`">
          <i class="icon-live active" />
        </abbr>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'stats-icons',
  props: ['post'],

  computed: {
    hasMedia() {
      return this.post.stats.images || this.post.stats.videos || this.post.stats.audios || this.post.stats.pdfs || this.post.stats.zips || this.post.stats.externalLink || this.post.stats.livestream
    }
  }
}
</script>

<style lang="scss">
.stats-icons {
  ul li {
    margin: 0 10px;
    color: black;

    abbr {
      i {
        height: 20px;
      }
    }
  }
}
</style>
